export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtNakladoveStrediskoTyp';
export const NAME = 'NakladoveStrediskoTyp';
